(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ct-product-page"]) return;
  try {
    
function initCtProductPages(root = document) {
  root.querySelectorAll('[data-ct-pdp]').forEach((page) => {
    if (page.dataset.ctReady) return;
    page.dataset.ctReady = 'true';
    const mainImage = page.querySelector('.ct-pdp__main-img');
    page.querySelectorAll('[data-ct-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.srcset = '';
      mainImage.src = thumb.dataset.image;
      mainImage.alt = thumb.dataset.alt || '';
      page.querySelectorAll('[data-ct-thumb]').forEach((item) => { item.classList.remove('is-active'); item.setAttribute('aria-pressed', 'false'); });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-pressed', 'true');
    }));
    const quantity = page.querySelector('[data-ct-quantity]');
    page.querySelector('[data-ct-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
    page.querySelector('[data-ct-plus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) + 1); });
    const variant = page.querySelector('[data-ct-variant]');
    variant?.addEventListener('change', () => {
      const option = variant.selectedOptions[0];
      page.querySelector('[data-ct-price]').textContent = option.dataset.price || '';
      const add = page.querySelector('[data-ct-add]');
      add.disabled = option.dataset.available !== 'true';
      add.textContent = add.disabled ? 'Sold out' : 'Add to cart';
    });
    const dialog = page.querySelector('[data-ct-dialog]');
    page.querySelector('[data-ct-zoom]')?.addEventListener('click', () => {
      const image = dialog.querySelector('img');
      image.src = mainImage?.src || '';
      image.alt = mainImage?.alt || '';
      dialog.showModal();
    });
    page.querySelector('[data-ct-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  });
}
initCtProductPages();
document.addEventListener('shopify:section:load', (event) => initCtProductPages(event.target));

  } catch(e) { console.error(e); }
})();
})();
